// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zf69H","placeholder":"styles_placeholder__FHr8X","image":"styles_image__xf3Z8"};